export default {
  allFuelSupplies: [],
  fuelSupply: {},
}
